import React from 'react';
import PickItemQuantityCounterContainer from '../PickItemQuantityCounterContainer';
import QuantityCounterSkeleton from '@afosto/app-components-react/QuantityCounter/QuantityCounterSkeleton';

const PickItemQuantityCounterSkeleton = () => (
  <QuantityCounterSkeleton ContainerElement={PickItemQuantityCounterContainer} />
);

export default PickItemQuantityCounterSkeleton;
